import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const signup = (data) => api.post('/auth/signup', data);
export const login = (data) => api.post('/auth/login', data);

// Business APIs
export const createBusinessProfile = (data) => api.post('/business/profile', data);
export const getBusinessProfile = () => api.get('/business/profile');

// Manager APIs
export const createManager = (data) => api.post('/manager/create', data);
export const getAllManagers = () => api.get('/manager/all');
export const getManagerByCode = (code) => api.get(`/manager/${code}`);

// Review APIs
export const generateReview = (data) => api.post('/review/generate', data);
export const submitReview = (data) => api.post('/review/submit', data);

// Admin APIs
export const getAllUsers = () => api.get('/admin/users');
export const createUser = (data) => api.post('/admin/users', data);
export const updateUser = (id, data) => api.put(`/admin/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/admin/users/${id}`);
export const toggleUserStatus = (id, isActive) => api.patch(`/admin/users/${id}/toggle-status`, { is_active: isActive });

export default api;
